import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import auth from '../../helpers/auth';
//import { actions } from "../../routes/Listing/modules/Listing";
import { connect } from 'react-redux';
import { actions } from '../../routes/selectWrapper/modules/select';
import WaitingPopUp from '../WaitiingPopUp/WaitingPopUp';
import { socket } from '../../helpers/socketHelper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import firebase from '../../helpers/firebase.config';
import {
  faUser,
  faPlus,
  faBell,
  faHome,
  faSearch,
  faTimes,
  faBars,
} from '@fortawesome/free-solid-svg-icons';
import {
  faHeart,
  faQuestionCircle,
  faStar,
} from '@fortawesome/free-regular-svg-icons';

export class SiteHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      logout: false,
      menu_bar: false,
    };
    this.toggle = this.toggle.bind(this);
  }

  componentDidMount() {
    // var starCountRef = firebase.database().ref('caocherlyAppointCall');
    // starCountRef.on('value', (snapshot) => {
    // const data = snapshot.val();
    // this.props.setWaitingList(data);
// });
    // if (Object.hasOwnProperty(socket).length > 0) {
    //   socket.on('new_request', (data) => {
    //     this.props.setWaitingList(data);
    //   });
    // }
    let rootEle = document.getElementById('adam');
    rootEle.classList.add('yss-web');
  }

  componentWillUnmount() {
    let rootEle = document.getElementById('adam');
    rootEle.classList.remove('yss-web');
  }

  toggle() {
    this.setState({
      menu_bar: !this.state.menu_bar,
    });
  }

  render() {
    let { waitingList } = this.props.selectState;
    let { menu_bar } = this.state;
    return (
      <Fragment>
        <header className="yss-site__header">
          {/* {waitingList.length
            ? waitingList.map((item, i) => (
                <WaitingPopUp
                  key={i}
                  name={item.username}
                  clickEvent={() => this.props.Reject(item)}
                  acceptEvent={() => this.props.Accept(item)}
                  avatar={item.avatar}
                />
              ))
            : null} */}
          <div className="yss-site__wrapper">
            <div className="yss-site__logo">
              <Link to="/" className="hover:text-gray-900">
                <img src="images/SoberListic_web_logo.png" />
              </Link>
            </div>
            <nav className="yss-site__nav">
              <a href="https://coacherly.com" className="hover:text-gray-900">
                Home
              </a>
              <Link to="/" className="hover:text-gray-900">
                Search Now
              </Link>
              <a
                href="https://coacherly.com/about-us/"
                className="hover:text-gray-900"
              >
                About Us
              </a>
              {/* <Link
                to="https://coacherlyblog.com/"
                className="hover:text-gray-900" target="_blank"
              > */}
              {/* </Link> */}
              <a
                href="https://coacherly.com/how-this-works/"
                className="hover:text-gray-900"
              >
                How This Works
              </a>
              <a
                href="https://coacherly.com/articles/"
                className="hover:text-gray-900"
              >
                Articles
              </a>
              {/* <Link to="/contact" className="hover:text-gray-900">
                Contact
              </Link> */}
              {auth.isAuthenticated ? (
                <Link
                  to={
                    auth.getUserType() === 'counsellor'
                      ? '/coach/dashboard/myprofile'
                      : '/dashboard/myprofile'
                  }
                  className="hover:text-gray-900"
                >
                  {/*<i className="fas fa-user"></i>*/}
                  My Account
                </Link>
              ) : (
                <Link to="/add-your-listings" className="hover:text-gray-900">
                  {/*<i className="fas fa-plus"></i>*/}
                  {/* Add Your Listing */}
                  Add Your Coaching Service
                </Link>
              )}
              {!auth.isAuthenticated ? (
                <Link to="/user/login" className="hover:text-gray-900">
                  Login
                </Link>
              ) : (
                <div className="flex">
                  <Link
                    to={
                      auth.getUserType() === 'counsellor'
                        ? '/coach/dashboard/notifications'
                        : '/dashboard/notifications'
                    }
                    title="Notifications"
                    className="hover:text-gray-900"
                  >
                    <FontAwesomeIcon icon={faBell} />
                  </Link>
                  <Link
                    onClick={() => this.props.logout()}
                    to="#"
                    title="Logout"
                    className="hover:text-gray-900"
                  >
                    Logout
                  </Link>
                </div>
              )}
            </nav>
          </div>
        </header>

        <header className="site--mobile__header mobile__header">
          <div className="mobile_top__bar">
            <div className="yss-site__logo">
              <Link to="/">
                <img src="images/SoberListic_web_logo.png" />
              </Link>
            </div>
            <button
              className="text-3xl focus:outline-none"
              onClick={() => this.toggle()}
            >
              {menu_bar ? (
                <FontAwesomeIcon icon={faTimes} />
              ) : (
                <FontAwesomeIcon icon={faBars} />
              )}
            </button>
          </div>
          {/* Dropdown Nav */}
          {menu_bar ? (
            <nav className="flex flex-col">
              <ul className="mobile__main__nav">
                {/* Links */}
                <li>
                  <Link
                    to="/"
                    className="hover:text-gray-900"
                    onClick={() => this.toggle()}
                  >
                    <i className="fas fa-home"></i>
                    Home
                  </Link>
                </li>
                <li>
                  <a
                    href="https://coacherly.com/about-us/"
                    className="hover:text-gray-900"
                    onClick={() => this.toggle()}
                  >
                    <i className="far fa-heart"></i>
                    About Us
                  </a>
                </li>
                <li className="mobile_menu_icon">
                  {/* <Link
                    to="https://coacherlyblog.com/"
                    className="hover:text-gray-900" target="_blank"
                  > */}
                  <a
                    href="https://coacherly.com/articles/"
                    className="hover:text-gray-900"
                    target="_blank"
                  >
                    Blog Home
                  </a>
                  {/* </Link> */}
                </li>
                <li>
                  <a
                    href="https://coacherly.com/how-this-works/"
                    className="hover:text-gray-900"
                    onClick={() => this.toggle()}
                  >
                    <i className="far fa-question-circle"></i>
                    How This Works
                  </a>
                </li>
                <li>
                  <Link
                    to="/"
                    className="hover:text-gray-900"
                    onClick={() => this.toggle()}
                  >
                    <i className="fas fa-search"></i>
                    Search Now
                  </Link>
                </li>
                {/* <li>
                  <Link
                    to="/contact"
                    className="hover:text-gray-900"
                    onClick={() => this.toggle()}
                  >
                    <i className="far fa-star"></i>
                    Contact
                  </Link>
                </li> */}
                <li>
                  {auth.isAuthenticated ? (
                    <Link
                      to={
                        auth.getUserType() === 'counsellor'
                          ? '/coach/dashboard/myprofile'
                          : '/dashboard/myprofile'
                      }
                      className="hover:text-gray-900"
                      onClick={() => this.toggle()}
                    >
                      <i className="fas fa-user"></i>
                      My Account
                    </Link>
                  ) : (
                    <Link
                      to="/add-your-listings"
                      className="hover:text-gray-900"
                      onClick={() => this.toggle()}
                    >
                      <i className="fas fa-plus"></i>
                      {/* Add Your Listing */}
                      Add Your Coaching Service
                    </Link>
                  )}
                </li>
                <li>
                  {!auth.isAuthenticated ? (
                    <Link to="/user/login" className="hover:text-gray-900">
                      Log In
                    </Link>
                  ) : (
                    <Link
                      onClick={() => this.props.logout()}
                      to="#"
                      className="hover:text-gray-900"
                    >
                      Log Out
                    </Link>
                  )}
                </li>
              </ul>
            </nav>
          ) : null}
        </header>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  selectState: state.selectState,
  CDashboardState: state.CDashboardState,
  NotificationState: state.NotificationState,
});

export default connect(mapStateToProps, actions)(SiteHeader);



// WEBPACK FOOTER //
// ./src/components/Header/SiteHeader.js